module.exports = __webpack_public_path__ + "img/farzana-christopher-149.28874eb8.jpg";